const TEXT_SIZE = 60;

/**
 * Note entity.
 */
class Note {
  /**
   *
   * @param {String} content
   * @param {String} author
   */
  constructor(content, author = undefined) {
    this.content = content;
    this.fixedSizedContent = content.length <= TEXT_SIZE ?
      content.padEnd(TEXT_SIZE, `${content} `) :
      content.substring(0, TEXT_SIZE);
    this.author = author;
    /**
     * Current note index.
     * @type {number}
     */
    this.index = undefined;
    /**
     * Total notes count.
     * @type {number}
     */
    this.totalCount = undefined;
  }

  /**
   *
   * @param {String} content
   * @param {String} author
   * @return {!Note} Note instance.
   */
  static newNote(content, author = undefined) {
    return new Note(content, author);
  }

  /**
   * Get html representation.
   * @return {string}
   */
  get html() {
    const contentHtml = `<p>${this.content}</p>`;
    const authorHtml = !this.author ? '' : `<p>${this.author}<p>`;
    const indexHtml = `<p>${this.index} / ${this.totalCount}<p>`;
    return contentHtml + authorHtml + indexHtml;
  }

  /**
   * Get html representation with fixed-sized text.
   * @return {string}
   */
  get htmlWithFixedSizedTxt() {
    return `<p>${this.fixedSizedContent}</p>`;
  }
}

/**
 * Take a note.
 */
class NoteTaker {
  /**
   *
   * @param {!Array<Note>} notes
   */
  constructor(notes) {
    this.notes = notes;
    this.totalNotesCount = this.notes.length;
  }

  /**
   * Notes repository.
   * @return {!Array<Note>}
   */
  static generateNotes() {
    /* eslint-disable max-len */
    return [Note.newNote('Разходете се сред природата. Ще Ви се отрази добре.', undefined), Note.newNote('Пари', undefined),
      Note.newNote('Един човек сам за себе си е нищо. Двама души, които си принадлежат, заедно правят света.', 'Ханс Марголиус'),
      Note.newNote('Любов<br>Love', undefined), Note.newNote('Нов приятел', undefined), Note.newNote('Запознанство<br/>Acquaintance', undefined), Note.newNote('Успех', undefined),
      Note.newNote('Когато се усмихвате на живота си, веднага започвате да живеете живот, за който си струва да се усмихвате.', undefined),
      Note.newNote('Ти си единственият човек на земята, който може да използва твоите възможности.', undefined), Note.newNote('Новина, вест', undefined),
      Note.newNote('Когато изпълваш живота на другите със светлина, не може да не бъдеш озарен и ти!', undefined), Note.newNote('Здраве', undefined),
      Note.newNote('Приятелите са важна съставка в рецептата на живота.', undefined), Note.newNote('Нов приятел', undefined),
      Note.newNote('Когато мислиш за положителни и хубави неща, ти ги привличаш към себе си.', undefined),
      Note.newNote('Най-добрите и красиви неща на света не могат да бъдат видяни, нито докоснати ... те се усещат в сърцето.', 'Хелън Келър'),
      Note.newNote('Човек е не където живее, а където обича.', 'латинска поговорка'),
      Note.newNote('Винаги, когато обръщаш на омразата с любов, ти обезсилваш омразата.', 'Уейн Дайър'),
      Note.newNote('Куфарите си стегни за пътешествие, до Генуа се приготви.', undefined),
      Note.newNote('Ако не можеш да намериш път - направи си сам.', undefined),
      Note.newNote('Промяната на Душата, е душата на всяка промяна.', 'Емерсон'),
      Note.newNote('Трънлив и зъл е на Живота ребуса. На кръст разпъва нашите души. Загубил всичко, не загубвай себе си. Единствено така ще го решиш.', 'Дамян Дамянов'),
      Note.newNote('Велики са тези, които разбират, че духовното е по-могъщо от каквато и да е материална сила и че мисълта управлява света.', undefined),
      Note.newNote('Ако съдбата ти затваря вратата, влез през прозореца.', undefined),
      Note.newNote('Истината не трябва да се казва така, че да я разберат. В нея трябва да повярват.', 'Уйлям Блейк'),
      Note.newNote('Този, който намира удоволствие в самотата, или е див звяр, или е Бог.', undefined),
      Note.newNote('Малка е ползата от очите, ако умът е сляп.', 'арабска пословица'),
      Note.newNote('Десетки свещи могат да се запалят от една, без да съкратят живота й. Щастието не намалява, ако се споделя.', 'Буда'),
      Note.newNote('Който иска да потуши страстите като ги задоволява, все едно гаси огън със слама.', undefined),
      Note.newNote('Не се присмивайте на човек, който прави две крачки назад, той може просто да се засилва.', undefined),
      Note.newNote('Постигането на душевно равновесие и хармония зависи от нас, от нашето желание да превъзмогнем притесненията, мрачните настроения и ниското самочувствие. Вярвай в себе си.', undefined),
      Note.newNote('Който се смее, вместо да беснее, е винаги по-силният.', undefined),
      Note.newNote('Ще живееш по-дълго, когато разбереш, че всеки момент, в който си се чувствал тъжен, е пропиляване на времето.', 'Рут Ренкел'),
      Note.newNote('Имаш нужната екипировка за успех - използвай я по предназначение.', undefined),
      Note.newNote('Направи добро - ще ти се върне.', undefined), Note.newNote('Сбъднати мечти.', undefined),
      Note.newNote('Радостни събития.', undefined), Note.newNote('Хубава изненада.', undefined),
      Note.newNote('Благоденствие.', undefined), Note.newNote('Любов и кашлица не се крият.', undefined),
      Note.newNote('Пада ти се днес парата - няма вече до заплата да се чудиш и се маеш как да свържеш двата края.', undefined),
      Note.newNote('Човекът не е направен, за да разбира живота, а за да го живее.', undefined),
      Note.newNote('В бизнеса постигаш завидни резултати.', undefined),
      Note.newNote('Очаква те радост безкрайно голяма - супер екскурзия в Европ за двама! И не забравяй, че трябва от чужбина подаръци за всички от сърце да има!', undefined),
      Note.newNote('Трябва да се покачиш на дървото, за да откъснеш плода.', undefined),
      Note.newNote('Със себе си съм имал повече проблеми, отколкото с всеки друг човек.', 'Дуайт Муди'),
      Note.newNote('Няма значение кой казва репликите, а кой суфлира / No matter who says lines, but who prompts.', undefined),
      Note.newNote('Време Ви е за купон.<br/>Party', undefined),
      Note.newNote('Ако си мислиш, че знаеш всичко, значи нещо ти убягва.', undefined),
      Note.newNote('Предстои Ви пътуване.', undefined), Note.newNote('Щастие.', undefined),
      Note.newNote('По-добре да бъдеш малка светлинка, отколкото голяма сянка.', undefined),
      Note.newNote('Най-същественото е невидимо за очите.', undefined), Note.newNote('Късмет.', undefined),
      Note.newNote('За две ръце протегнати насреща, земята бих до края извървял. За две очи, като звезди горещи, аз цялата си топлина бих дал.', undefined),
      Note.newNote('Дърво с дълбоки корени не се бои дори от най-силния вятър.', 'Конфуции'),
      Note.newNote('Безизходно положение няма! Това е пауза между две хрумвания.', undefined),
      Note.newNote('Ще е празник за душата, любов ще ти върти главата!', undefined),
      Note.newNote('След любовен световъртеж, ще вдигнеш ти годеж.', undefined),
      Note.newNote('Книгите вземи, в учението ще ти върви.', undefined),
      Note.newNote('Малко юначе в къщата ти ще проплаче.', undefined),
      Note.newNote('Здраве в изобилие и радост до безсилие.', undefined),
      Note.newNote('С нова хубава кола ще се возиш из града!', undefined),
      Note.newNote('Сватба ще има през тази година и тя ще бъде незабравима!', undefined),
      Note.newNote('Нов човек ще се роди.', undefined),
      Note.newNote('С градина, басейн и тераса, къща ще имаш от класа!', undefined),
      Note.newNote('Тази година булка и не чакай догодина, ами връзвай люлка.', undefined),
      Note.newNote('Колкото звезди по небето, толкова пари в портмонето.', undefined),
      Note.newNote('Споделена любов ще плени сърцето ти!', undefined),
      Note.newNote('За теб е веселие, нормалното ежедневие.', undefined),
      Note.newNote('Новата ти къща погледи ще връща, с обич напълни я и с любов стопли я!', undefined),
      Note.newNote('Животът ти ще е изпълнен с любов, енергия, радост, настроение!', undefined),
      Note.newNote('Позитивни промени.', undefined),
      Note.newNote('Мнодо добрини, ще сториш ти.', undefined),
      Note.newNote('Ще влезеш в елитен институт, с големи мозъци прочут!', undefined),
      Note.newNote('Добро здраве и сили.', undefined), Note.newNote('Успехи във всичко.', undefined),
      Note.newNote('Благословен живот.', undefined),
      Note.newNote('Иди учи, учи, учи.', undefined),
      Note.newNote('Ще завилнее пак душата - любов ще ти подкоси краката!', undefined),
      Note.newNote('Мир на земята.', undefined),
      Note.newNote('Незабравими приключения и пътешествия.', undefined),
      Note.newNote('Ще се сдобиеш с нещо ценно, опази го непременно.', undefined),
      Note.newNote('Ще си сред обич цял фонтан, ще се гмуркаш надълбоко в любовен океан!', undefined),
      Note.newNote('Работата ще е песен, а животът ти чудесен! На света се усмихни и грижите си забрави!', undefined),
      Note.newNote('Честити ще са дните, славата те следва по петите.', undefined),
      Note.newNote('Пътешествия екзотични, в топли държави различни.', undefined),
      Note.newNote('Ученето продължава цял живот.', undefined),
      Note.newNote('Смело стъпвай напред, късметът е с теб навред.', undefined),
      Note.newNote('Плюй си на петите и далече беж, че очаква те годеж!', undefined),
      Note.newNote('Нови проекти и смели мечти, залавяй се бързо, не чакай, не спи!', undefined),
      Note.newNote('Твоето най-голямо стремление е едно постоянно учение.', undefined),
      Note.newNote('Пада ти се здраве, но без много "Наздраве"!', undefined),
      Note.newNote('Ще си имаш бебче - пухкаво и бяло като хлебче!', undefined),
      Note.newNote('Животът е необикновено хубав, ако човек не се страхува от него и го приема с открита душа.', undefined),
      Note.newNote('Не се подчинявай на глупав човек и не взимай страната на силния.', 'Библейска мъдрост'),
      Note.newNote('Любов и щастие ще пълнят твойта гръд, и рози ще застилят твоя път.', undefined),
      Note.newNote('Ще откриеш бизнес нов и проблемът е готов.', undefined),
      Note.newNote('В живота нищо не се постига лесно, но за теб ще се подреди чудесно.', undefined),
      Note.newNote('Щура вечер ти се очертава, подготви се за забава.', undefined),
      Note.newNote('Змията винаги твърди, че хапе с лечебна цел.<br/>| The snake always claims that bites with curative intent. |', undefined),
      Note.newNote('Провалът е само една добра възможност да започнеш всичко отначало. По по-разумен начин...', 'Хенри Форд'),
      Note.newNote('Странно нещо е животът - ако откажеш да приемеш друго, освен най-доброто, много често го получаваш.', 'Съмърсет Моъм'),
      Note.newNote('В чужда манджа сол не туряй.', undefined), Note.newNote('Покритото мляко, и котките не го лочат.', 'Българска поговорка'),
      Note.newNote('Имане без труд лесно се пилей.', undefined),
      Note.newNote('Човек е свободен, когато контролира себе си и не се опитва да контролира другите.', undefined),
      Note.newNote('Да бъдеш милостив и добър не е белег на слабост и отчаяние, а проява на сила и решителност.', undefined),
      Note.newNote('Някои хора са родени добри, други правят добро.', undefined),
      Note.newNote('През какво да преминем избира съдбата, но как да преминем избираме ние.<br/>| The destiny elects what to pass through, but we choose how to pass. |', undefined),
      Note.newNote('Когато си се родил си плакал, докато другите около теб са се усмихвали. Живей и се усмихвай дори на другите да им се плаче.', undefined),
      Note.newNote('Никога, никога, никога, никога не се предавай.', 'Уинстън Чърчил'),
      Note.newNote('Добрите думи от приятели ни се струват кратки и лесно изречени, но ехото им е наистина безкрайно.', undefined),
      Note.newNote('Нов приятел.', undefined),
      Note.newNote('Работата се върши докато стане както трябва или докато се убедиш, че не може да стане така.', undefined),
      Note.newNote('За какво да живеем, ако не за да правим живота по-малко труден един за друг?', undefined),
      Note.newNote('Радостта не е във вещите, тя е в нас.', undefined),
      Note.newNote('Велики приключения очакват тези, които имат желание да завият зад ъгъла.', undefined),
      Note.newNote('Победата е винаги там, където има съгласие.', 'Сир'),
      Note.newNote('Прави повече от това да мислиш. Реализирай.', undefined),
      Note.newNote('Тайната да вървиш напред е да потеглиш.', undefined),
      Note.newNote('За плахия и колебаещия се, всичко е невъзможно, защото му изглежда така.', 'Сър Уолтър Скот'),
      Note.newNote('Чудесата ще започнат да стават, когато започнете да влагате повече енергия в мечтите си, отколкото в страховете си.', undefined),
      Note.newNote('Човек живее, колкото трябва, и умира, когато се съгласи.', 'Петър Димков'),
      Note.newNote('Хранете се, за да живеете, а не живейте, за да се храните.', 'Петър Димков'),
      Note.newNote('Движението е живот, застоят - смърт. Не се бойте от болести! Това е задължително условие да не боледувате.', 'Петър Димков'),
      Note.newNote('Ако посоката, в която си се запътил, ти носи радост, не питай какъв ще е пътят. Просто върви!', undefined),
      Note.newNote('Луд умора няма.', 'Българска поговорка'),
      Note.newNote('Барабар Петко с мъжете.', 'Българска поговорка'),
      Note.newNote('Щастието е само на една мисъл разстояние.', undefined),
      Note.newNote('Слабите хора чакат да настъпи благоприятно обстоятелство, силните го създават.', undefined),
      Note.newNote('Не се учи как да станеш богат, учи се как да станеш щастлив.', undefined),
      Note.newNote('Кефът цена няма, ама струва пари.', 'Бат\' Жоро'),
      Note.newNote('Насила хубост не става.', 'Българска поговорка'),
      Note.newNote('Кое е по-важно за успеха - талантът или труда? А кое колело на велосипеда е по-важно - предното или задното?.' +
        '<br/>| What is more important for success - the talent or the labor? And which wheel of the bicycle is more important - the front or the rear one? |', undefined),
      Note.newNote('Можем ли да освободим света от злосторници? Вероятно толкова, колкото и да го населим със Светци.' +
        '<br/>| Can we rid the world of evildoers? Probably as much as to populate it with saints. |', 'Тома Томов | Toma Tomov'),
      Note.newNote('Човек е щастлив, когато притежава това, което сам обича, а не това, което другите харесват.', undefined),
      Note.newNote('Животът е твърде кратък, за да вършим неща, които не обичаме.', undefined),
      Note.newNote('Никога не е късно да бъдеш този, който си можел да станеш.', 'Джордж Елиът | George Eliot'),
      Note.newNote('Скучае само онзи, който няма за какво да разговаря със себе си.', undefined),
      Note.newNote('Всяко препядствие е нова възможност. Всяко препядствие е проверка!', undefined),
      Note.newNote('Нищо велико не е постигнато без ентусиазъм.', 'Ралф Уолдо Емерсон'),
      Note.newNote('Когато ласкаеш някого, той се възхищава от добрият ти вкус.', 'Георг Лихтенберг'),
      Note.newNote('Мотивацията почти винаги е по-важна от простия талант.', 'Норман Августин'),
      Note.newNote('Където и да отиваш, отивай с цялото си сърце.', undefined),
      Note.newNote('Владей страстите, иначе те ще те завладеят.', undefined),
      Note.newNote('Най-доброто лекарство срещу гнева е времето.', 'Сенека'),
      Note.newNote('Нищо не доставя толкова голямо удоволствие, както добре свършената работа.', undefined),
      Note.newNote('Щастието се увеличава, когато се споделя с други.', 'Жорж Льометр'),
      Note.newNote('Където са приятелите, там е богатството.', 'Плавт'),
      Note.newNote('Човек сред многото приятели има само малко верни.', 'Плавт'),
      Note.newNote('Спокойно можеш да се наслаждаваш само на това, което можеш да загубиш без огорчение.', 'Жан-Жак Русо'),
      Note.newNote('За верния приятел никога не може да се направи твърде много.', 'Хенрик Ибсен'),
      Note.newNote('Губим време, за да си осигурим работно време и водим битки, за да живеем в мир.', 'Аристотел'),
      Note.newNote('Успех е да получиш, каквото искаш. Щастие е да харесваш, каквото получаваш!', undefined),
      Note.newNote('Ние мислим твърде много и чувстваме твърде малко.', 'Чарли Чаплин'),
      Note.newNote('Ден без смях е пропилян ден.', 'Чарли Чаплин'),
      Note.newNote('За да се смееш искрено, трябва да можеш да вземеш болката си и да поиграеш с нея.', 'Чарли Чаплин'),
      Note.newNote('Трябва ти сила, само ако възнамеряваш да направиш нещо лошо. Във всички останали случаи любовта ти е напълно достатъчна.', 'Чарли Чаплин'),
      Note.newNote('Провалът е важен. Изисква се кураж, за да се направиш на глупак.', 'Чарли Чаплин'),
      Note.newNote('Нищо не е вечно в този порочен свят – дори проблемите.', 'Чарли Чаплин'),
      Note.newNote('Смехът е лекарство за болката.', 'Чарли Чаплин'),
      Note.newNote('Броят на глупостите, извършени по волята на разума, са много повече, отколкото тези, които са извършени от чиста глупост.', 'Чарли Чаплин'),
      Note.newNote('Животът щеше да е прекрасен, ако хората просто можеха да те оставят на мира.', 'Чарли Чаплин'),
      Note.newNote('Една жена може да направи милионер всеки мъж милиардер.', 'Чарли Чаплин'),
      Note.newNote('Едно убийство прави човек престъпник, а милиони убийства — герой. Разликата е в мащабите.', 'Чарли Чаплин'),
      Note.newNote('Истинският характер на човек си проличава, когато е пиян.', 'Чарли Чаплин'),
      Note.newNote('Жените нямат недостатъци, те имат особености.', 'Чарли Чаплин'),
      Note.newNote('Аз вярвам, че могъществото на смеха и сълзите може да противодейства на ненавистта и страха.', 'Чарли Чаплин'),
      Note.newNote('Моята болка може да бъде причината за нечий смях, но не искам никога моят смях да бъде причина за нечия болка.', 'Чарли Чаплин'),
      Note.newNote('За да направя комедия, са ми нужни само парк, полицай и красиво момиче.', 'Чарли Чаплин'),
      Note.newNote('Показан в крупен план, животът е трагедия, но е комедия в общ.', 'Чарли Чаплин'),
      Note.newNote('Сам по себе си човекът е гений, но в масата той се превръща в безмозъчно чудовище, в брутален идиот, който е готов да отиде навсякъде, където му кажат.', 'Чарли Чаплин'),
      Note.newNote('И все пак ми е мъчно за нямото кино. Така хубаво беше да видиш как жената си отваря устата, а глас не се чува!', 'Чарли Чаплин'),
      Note.newNote('Най-тъжното нещо, което мога да си представя, е как свиквам с лукса.', 'Чарли Чаплин'),
      Note.newNote('Който никога не е бил дете, никога няма да бъде и възрастен.', 'Чарли Чаплин'),
      Note.newNote('Отчаянието е наркотик. То приспива ума, прави го безразличен.', 'Чарли Чаплин'),
      Note.newNote('На най-важните житейски кръстопътища няма никакви пътни знаци.', 'Чарли Чаплин'),
      Note.newNote('Не виждам в бедността нищо привлекателно или поучително.', 'Чарли Чаплин'),
      Note.newNote('Не обичам слоновете. Толкова са силни, а толкова послушни...', 'Чарли Чаплин'),
      Note.newNote('Няма нищо по-лесно от това да описваш спомени, които отдавна са ти излетели от главата.', 'Чарли Чаплин'),
      Note.newNote('Щастието е уморено страдание.', 'Чарли Чаплин'),
      Note.newNote('Аз съм в мир с Господ. Конфликтът ми е с човека.', 'Чарли Чаплин'),
      Note.newNote('Безспокой се повече за съвестта си, отколкото за репутацията си, защото твоята съвест- това си ти, а репутацията ти - това е, което другите мислят за теб. А това, което другите мислят за теб - си е техен проблем.', 'Чарли Чаплин'),
      Note.newNote('Бедната мъдрост често става роб на богатата глупост.', 'Уилям Шекспир'),
      Note.newNote('Успехът е да получите това, което искате. Щастието е да искате това, което получавате.', 'Дейл Карнеги'),
      Note.newNote('Вложете сърцето, ума, интелекта и душата си дори в най-дребните си постъпки. Това е тайната на успеха.', 'Суами Сивананда'),
      Note.newNote('Да ти кажа ли от какво човек става безчувствен и циничен? От това, че са го предавали, захвърляли и заменяли за други хора, а той е бил готов да даде, ако не всичко, то твърде много.', 'Ал Пачино'),
      Note.newNote('Животът е пътуване с влак. Първо минаваш през един дълъг тунел, без да знаеш къде води той. След това, някъде към 50-те, влакът излиза от тунела на светло и в далечината виждаш голяма планина - крайната цел на пътуването. Аз вече зърнах планината. Това е едно ужасно усещане, което смразява кръвта.', 'Ал Пачино'),
      Note.newNote('Лесно е да се заблуди окото, но е трудно да се заблуди сърцето.', 'Ал Пачино'),
      Note.newNote('Най-трудното нещо в това да бъдеш известен, е, че хората винаги са мили с вас. Водиш разговор и всеки се съгласява с това, което казваш - дори и да говориш пълни глупости. Трябва хората да могат да ви кажат, каквото не искате да чуете.', 'Ал Пачино'),
      Note.newNote('Винаги казвам истината, освен в случаите, когато лъжа.', 'Ал Пачино'),
      Note.newNote('Цялата работа при звездите ... е като... издигат те някъде нагоре и ставаш звезда, сетне суперзвезда. Какво ще рече това? Че си някъде горе, извън останалите. Това може да се окаже тъжно.', 'Ал Пачино'),
      Note.newNote('Моите слабости ... Може би, ако ме бяхте питали за силните ми страни, щях да направя същата пауза. Може би те са едно и също нещо.', 'Ал Пачино'),
      Note.newNote('За хората, за които съществувам от време на време, аз нямам време.', 'Ал Пачино'),
      Note.newNote('Когато всичко работи, човек престава да се показва и доказва на другите. Когато човек е силен, той излъчва спокойствие и не влиза в излишни битки. Когато обикнеш настоящето, спираш да бъдеш обсебен. Тогава човек става самостоятелен, уповава се на вярата в себе си, знае на какво е способен и не се нуждае да убеждава другите да вярват в него.', 'Ал Пачино'),
      Note.newNote('Живей според възможностите си, за да не се отравяш сам.', 'Петър Димков'),
      Note.newNote('Планината пречиства душата и ободрява духа. Бъдете весели, бодри и с ведри мисли, за да живеете в радост и щастие.', 'Петър Димков'),
      Note.newNote('Два часа сън преди полунощ се равняват на осем след полунощ.', 'Петър Димков'),
      Note.newNote('Добротата е драгоценно здраве. Интересувайте се от живота - главното условие да останете в него.', 'Петър Димков'),
      Note.newNote('Причините за заболяванията се коренят в голяма степен в лошите мисли и отклонението от природата - извор на здраве.', 'Петър Димков'),
      Note.newNote('Жив си, когато не се отказваш.', 'Боян Петров'),
      Note.newNote('Много енергия хаби нашето общество в стремежа да се противопоставяме един на друг. Бих призовал всички хора да бъдат по-смирени, съобразявайки се с чуждото мнение. Противопоставянето по никакъв начин не ни помага да сме психологически устойчиви.', 'Тодор Димитров - Ел Капитан'),
      Note.newNote('Покорявам не върхове, а единствено себе си.', 'Боян Петров'),
      Note.newNote('Винаги изглежда невъзможно, докато някой го направи.', 'Нелсън Мандела'),
      Note.newNote('Лудост: да правиш едно и също нещо отново и отново и да очакваш различни резултати.', 'Алберт Айнщаин'),
      Note.newNote('Пропуснал съм над 9000 изстрела в кариерата си. Загубил съм почти 300 мача. 26 пъти ми се доверяваха да направя финалния и решаващ изстрел и съм пропускал. Провалял съм се много пъти в живота си. И точно заради това успях.', 'Майкъл Джордан'),
      Note.newNote('Тайната да излезеш начело, е да започнеш.', 'Марк Твен'),
      Note.newNote('Късметът е, когато подготовката срещне възможността.', 'Опра Уинфри'),
      Note.newNote('Най-великите спортни постижения се случват в съзнанието, не в тялото.', 'Мат Фицджералд'),
      Note.newNote('Съзнанието е всичко. Мускулите - парченца гума. Всичко, което съм, се дължи на съзнанието ми.', 'Пааво Нурми, олимпийска легенда'),
      Note.newNote('Всичко, което се случва, е за мое добро и аз ще разбера защо!', 'Юли Тонкин'),
      Note.newNote('Винаги помни, че най-хубавото нещо на миналото е, че е минало, най-хубавото на настоящето е, че е тук и сега, и най-хубавото на бъдещето е, че все още не е дошло!', 'Юли Тонкин'),
      Note.newNote('Ако не се радваш на това, което имаш в момента, няма да се радваш и на това, което ще постигнеш!', 'Юли Тонкин'),
      Note.newNote('Вярата в безграничните ни възможности е вятърът, който държи хвърчилото ни винаги нагоре!', 'Юли Тонкин'),
      Note.newNote('Има само едно истинско богатство - и то е общуването между хората.', undefined),
      Note.newNote('Наше задължение е да пазим тялото си в добро здраве, в противен случай не можем да опазим мисълта си силна и бистра.', 'Буда'),
      Note.newNote('Ей го слънцето! Утрото е хубаво, колко по-хубав ще бъде денят!', undefined),
      Note.newNote('Колкото повече се потиш по време на мир, толкова по-малко ще кървиш по време на война.', 'Норман Шварцкопф'),
      Note.newNote('Животът е една изпита чаща, а водата все тече... тече... тече.', undefined),
      Note.newNote('Както бистрата вода оглежда слънцето от синьото небе, тъй душата е с надежда да проблесне в чистото сърце.', undefined),
      Note.newNote('Ромоли чешмата - пей, напява<br/>за далечни стари времена<br/>в спомени мили образи представя<br/>на лица със светли имена.', undefined),
      Note.newNote('Бързо и безспир текат водите<br/>бързо и животът ни тече<br/>и затуй, о брате мой към висините,<br/>ум безспир насочвай и сърце.', undefined),
      Note.newNote('Музиката в душата може да бъде чута от Вселената.<br/>Бъдете доволни от това, което имате. Радвайте се на нещата такива каквито са.<br/>Когато осъзнаете, че нищо не ви липсва, целият свят ви принадлежи.<br/>Ако осъзнаете, че всичко се променя, няма да се крепите за нищо.<br/>И най-дългото пътешествие започва с първата крачка.', 'Лао Дзъ'),
      Note.newNote('Онова, което не можеш да избегнеш, посрещни с добре дошло.', 'Китайска мъдрост'),
      Note.newNote('Кой е най-щастливия момент от деня? - Рано сутрин с роса по тревата.', 'Боян Петров'),
      Note.newNote('Някои от най-хубавите ти дни, все още не са се случили.', undefined),
      Note.newNote('Всеки ден излизай на разходка. Чудесата стават навсякъде.', undefined),
      Note.newNote('Една блага дума често е по-освежаваща от водата и сянката.', 'Буда'),
      Note.newNote('Знанието няма граници.', 'Веселин Измирлиев'),
      Note.newNote('Детството е вълшебство. Нека винаги да го откриваш в себе си.', undefined),
      Note.newNote('Безгранично щастие, колекция от незабравими моменти и слънчеви хоризонти пред мечтите ти.', undefined),
      Note.newNote('Все още не съм срещал котка, която да се притеснява,<br/>какво си мислят мишките за нея.', undefined),
      Note.newNote('Научете се да казвате важни неща с делничен тон.<br/>| Learn to say important things with casual tone. |', undefined),
      Note.newNote('Любовта не кара света да се върти. Любовта е това, което прави пътуването ценно.', 'Елизабет Браунинг'),
      Note.newNote('Банкерът е човек, който ти дава назаем чадър, когато времето е хубаво и си го взима обратно, когато завали.<br/>| The banker is someone who lends you an umbrella when the weather is nice and takes it back, when it rains. |', undefined),
      Note.newNote('Ставаш свободен в момента, в който преставаш да търсиш извън себе си някой, който да ти реши проблемите.', undefined),
      Note.newNote('Почти всички нещастия идват оттам, че непрекъснато се сравняваме с другите.', 'Хорас Браун'),
      Note.newNote('Ревността е страх от превъзходството на другия.', undefined),
      Note.newNote('Мечтите трябва да са толкова големи, че да можем да растем в тях.', 'Джоузи Бисет'),
      Note.newNote('Чувствата не мамят. Мамят само съставените по тях съждения.', 'Гьоте'),
      Note.newNote('Възможностите съществуват, за да се възползваме от тях.', undefined),
      Note.newNote('Никой не се ражда мъдър, сам става такъв.<br/>| Nobody was born wise, they become such by themselves. |', undefined),
      Note.newNote('Блаженството на тялото е в здравето, блаженството на ума - в знанието.', 'Талес'),
      Note.newNote('Любовта разрешава всички противоречия.', 'Петър Дънов'),
      Note.newNote('Приятелството също подхранва дълголетието. Приятелството дава морална сила. То е богатство на ума и сърцето.', 'Петър Димков'),
      Note.newNote('Никой не е остарял, преди да загуби интерес към живота.', 'Петър Димков'),
      Note.newNote('Не падай духом. В живота нищо не струва повече от живота, за да загубваш вяра в него.', 'Петър Димков'),
      Note.newNote('Добрият човек е като онзи, който върви по пясъка, не вдига шум, но оставя следи.', undefined),
      Note.newNote('Това, което ни прави богати, са нашите действия.', undefined),
      Note.newNote('Всеки проблем си има своето решение...<br/>просто ви трябва време, за да го откриете.', undefined),
      Note.newNote('Избягвайте флиртове на работното място.', undefined),
      Note.newNote('Някои хора се опитват да бъдат велики, а други просто се виждат велики.', undefined),
      Note.newNote('Да се ядосваш значи да наказваш себе си за грешките на другите.', 'Оноре дьо Балзак'),
      Note.newNote('Искаш ли да знаеш кой си? Не питай. Действай!<br>Действието ще те отличи и определи.<br>| Do you want to know who you are? Don’t ask. Act!<br>Action will delineate and define you. |', 'Thomas Jefferson'),
      Note.newNote('Не става въпрос за картите, които са ти раздадени, а как играеш ръката.<br>| It’s not about the cards you’re dealt, but how you play the hand. |', 'Randy Pausch'),
      Note.newNote('Думите, които изговаряш, стават къщата, която обитаваш.<br>| The words you speak become the house you live in. |', 'Hafiz'),
      Note.newNote('Не се подавай на страховете си. Ако го направиш, няма да можеш да разговаряш със сърцето си.<br>| Don’t give in to your fears. If you do, you won’t be able to talk to your heart. |', 'Paulo Coelho'),
      Note.newNote('Не се страхувай от провал. Не провалът, но ниската цел, е престъплението. Във великите опити, славно е дори да се провалиш.<br>| Don’t fear failure. Not failure, but low aim, is the crime. In great attempts, it is glorious even to fail. |', 'Брус Лий | Bruce Lee'),
      Note.newNote('Препядствията не блокират пътя. Те са пътя.<br>| Obstacles do not block the path. They are the path. |', 'Zen Proverb'),
      Note.newNote('Всички сме родени за любов. Това е принципът на съществуването и единствената му цел.', 'Бенджамин Дизраели'),
      Note.newNote('Очакването уморява, но колко по-лошо би било, ако няма какво да се чака.', 'Джордж Бърнард Шоу'),
      Note.newNote('Ти си специален. Ти си божие чудо. Усмивката е твоя чар, ръцете ти са твоята сила, а душата е огледало на твоите думи! Бъди като водата.', undefined),
      Note.newNote('Притежаваш най-мощната сила - себе си! Ходи с мъдрите и ще станеш мъдър.', undefined),
      Note.newNote('Ако не е редно - не го прави, ако не е вярно - не го казвай! Стой далеч от клевети и суета. Пазете хигиена на езика си, тялото, работата и в отношенията.', undefined),
      Note.newNote('Рая и ада не са места, а състояния! Вярата е вратата. Отворете на доброто, на щастието, на здравето.', undefined),
      Note.newNote('Деца, уважавайте родителите.<br>Родители, вслушвайте се в децата.<br>Възпитавайте се взаимно с топъл тон, с мили думи, с любов.<br>Семейството е твоя отбор!<br>Уважението е майката.<br>Вярата е бащата.', undefined),
      Note.newNote('Не се бой от смъртта, но започни да живееш истински.<br>Тук сте, за да бъдете щастливи. Направете се.<br>Животът е според мислите.', undefined),
      Note.newNote('Привилегия е да си жив!<br>Обичайте се, уважавайте се, без его.<br>Днес е ново начало. Запазете себе си чисти, тяло и дух!', undefined),
      Note.newNote('Любовта е главния ключ, който отваря вратите на щастието.', undefined),
      Note.newNote('Понякога е добре да спреш да преследваш щастието и просто да си щастлив.', undefined),
    ];
    /* eslint-enable max-len */
  }

  /**
   *
   * @return {!Note} Randomly-picked note.
   */
  takeNote() {
    return this.getRandomNote(this.notes);
  }

  /**
   *
   * @param {Note[]} arr Array
   * @return {Note} Random item.
   */
  getRandomNote(arr) {
    const randomIndex = NoteTaker.getRandomIndex(this.totalNotesCount);
    const note = arr[randomIndex];
    note.index = randomIndex + 1;
    note.totalCount = this.totalNotesCount;
    return note;
  }

  // eslint-disable-next-line require-jsdoc
  static getRandomIndex(arrLength) {
    return Math.floor(Math.random() * arrLength);
  }
}

/**
 * DOM manipulations in order to present the notes.
 */
export class NoteViewer {
  /* eslint-disable indent */
  /**
   * @param {!Object} rotateBtn jQuery object.
   * @param {!Object} noteDisplayBox jQuery object.
   * @param {!number} rotateIntervalMs
   * @param {Array<Note>} notes
   */
  constructor(rotateBtn, noteDisplayBox, rotateIntervalMs = 100,
    notes = NoteTaker.generateNotes()) {
    // eslint-enable indent
    this.rotateIntervalMs = rotateIntervalMs;
    this.rotateBtn = rotateBtn;
    this.noteDisplayBox = noteDisplayBox;
    this.noteTaker = new NoteTaker(notes);
    this.timer = null;
    this.currentNote = null;
  }

  /**
   * Displays current note.
   */
  displayNote() {
    this.noteDisplayBox.html(this.currentNote.html);
  }

  // eslint-disable-next-line require-jsdoc
  displayNotePreview() {
    this.currentNote = this.noteTaker.takeNote();
    this.noteDisplayBox.html(this.currentNote.htmlWithFixedSizedTxt);
  }

  /**
   * Public. Starts rotating notes.
   * @param {Object} event DOM event.
   * @return {undefined}
   */
  startRotate(event = undefined) {
    this.rotateBtnClickHandler = this.pickLuckyNote;
    this.rotateBtnLabel = 'Изтегли';
    this.rotateBtnTitle = 'Късметче си вземи';
    this.currentNote = null;
    this.rotateNotes();
  }

  /**
   * Rotate notes continuously.
   */
  rotateNotes() {
    this.timer = window.setTimeout(() => {
      this.displayNotePreview();
      window.clearTimeout(this.timer);
      this.rotateNotes();
    }, this.rotateIntervalMs);
  }

  /**
   * Picks and displays a lucky note.
   * @param {Object} event DOM event.
   * @return {undefined}
   */
  pickLuckyNote(event) {
    window.clearTimeout(this.timer);
    this.displayNote();
    this.rotateBtnClickHandler = this.startRotate;
    this.rotateBtnLabel = 'Старт';
    this.rotateBtnTitle = 'Натисни за следващо късметче';
  }

  /**
   * Rotate button label.
   * @param {String} btnLbl
   */
  set rotateBtnLabel(btnLbl) {
    this.rotateBtn.html(btnLbl);
  }

  /**
   * Rotate button title.
   * @param {String} btnTitle
   */
  set rotateBtnTitle(btnTitle) {
    this.rotateBtn.attr('title', btnTitle);
  }

  /**
   * Rotate button click handler.
   * @param {Function} handleFn
   */
  set rotateBtnClickHandler(handleFn) {
    this.rotateBtn.off('click');
    this.rotateBtn.click(handleFn.bind(this));
  }
}
